var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.costPerformanceText || _vm.fineDiscount)?_c('div',{directives:[{name:"zpm",rawName:"v-zpm",value:({
    sortname: '性价比解读模块',
    sortid: 10,
    backup: {
      moduleContent: _vm.fineDiscount && _vm.fineDiscount.labelId
    },
    legoareabackup: {
      sortName: '性价比解读模块',
      sortid: 10,
      moduleContent: _vm.fineDiscount && _vm.fineDiscount.labelId
    },
    areaexposure: 105
  }),expression:"{\n    sortname: '性价比解读模块',\n    sortid: 10,\n    backup: {\n      moduleContent: fineDiscount && fineDiscount.labelId\n    },\n    legoareabackup: {\n      sortName: '性价比解读模块',\n      sortid: 10,\n      moduleContent: fineDiscount && fineDiscount.labelId\n    },\n    areaexposure: 105\n  }"}],staticClass:"cost-performance",class:{ 'cost-performance__super': _vm.superColor },on:{"click":_vm.listenClickTab}},[_c('img',{staticClass:"first-icon",attrs:{"src":_vm.$setPicSize(
        _vm.superColor
          ? 'https://pic5.zhuanstatic.com/zhuanzh/aa9fe111-f2f0-4e49-9051-e874d4b4816f.png'
          : 'https://pic4.zhuanstatic.com/zhuanzh/356aa995-aebf-4e37-8149-cdcaee988d5f.png'
      ),"alt":""}}),(_vm.fineDiscount)?_c('div',{staticClass:"fine-discount-text",class:{
      'no-cost-text': !_vm.costPerformanceText
    }},[_vm._v(" "+_vm._s(_vm.fineDiscount.tagName)+" ")]):_vm._e(),(_vm.costPerformanceText)?_c('div',{staticClass:"cost-desc"},[_vm._v(" "+_vm._s(_vm.costPerformanceText)+" ")]):_vm._e(),_c('img',{staticClass:"end-icon",attrs:{"src":_vm.$setPicSize(
        _vm.superColor
          ? 'https://pic5.zhuanstatic.com/zhuanzh/6cb75868-3b1b-4b27-a5a8-ce8e7eb6989c.png'
          : 'https://pic1.zhuanstatic.com/zhuanzh/a2e5f522-bb31-4c8c-b2d8-91ac67f58a66.png'
      ),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }